import { cn } from '@forest/shared'

// Two-arrow refresh glyph for the Daily Picks refresh button. 26px unless the
// caller's `class` sizes it; strokes in `currentColor`. Decorative: the
// button's name is its price text.
export function RefreshIcon(props: { class?: string }) {
  return (
    <svg
      aria-hidden="true"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={cn('size-[26px]', props.class)}
    >
      <path
        d="M18.1652 12.9229C18.6088 12.9874 18.9168 13.399 18.8527 13.8428C18.6783 15.0507 18.1409 16.2459 17.1936 17.1934L17.1916 17.1953C15.0247 19.3504 11.6092 19.4932 9.28438 17.6201V18.6123C9.28419 19.0608 8.92038 19.4247 8.47188 19.4248C8.02326 19.4248 7.65956 19.0609 7.65938 18.6123V15.7197C7.65938 15.271 8.02315 14.9072 8.47188 14.9072H11.3645C11.813 14.9074 12.177 15.2711 12.177 15.7197C12.1768 16.1682 11.8129 16.532 11.3645 16.5322H10.5402C12.2148 17.6989 14.5423 17.5386 16.0461 16.043C16.7223 15.366 17.1154 14.5029 17.2443 13.6104C17.3085 13.1663 17.7211 12.8588 18.1652 12.9229ZM17.5285 6.57617C17.9771 6.57636 18.341 6.94005 18.341 7.38867V10.2812C18.341 10.7298 17.9771 11.0936 17.5285 11.0938H14.6359C14.1872 11.0938 13.8235 10.7299 13.8234 10.2812C13.8234 9.83252 14.1872 9.46875 14.6359 9.46875H15.4563C13.773 8.3008 11.4483 8.46433 9.95625 9.95605C9.27785 10.6345 8.88492 11.488 8.75606 12.3896C8.6924 12.8336 8.28022 13.1416 7.83614 13.0781C7.39225 13.0144 7.08325 12.6032 7.14668 12.1592C7.32124 10.9378 7.86054 9.75402 8.80684 8.80762C10.9666 6.64791 14.384 6.50855 16.716 8.38184V7.38867C16.716 6.93994 17.0798 6.57617 17.5285 6.57617Z"
        fill="currentColor"
      />
    </svg>
  )
}
